const masks = {
  cep: '#####-###',
  cpf: '###.###.###-##',
  phone: '(##)  ####-####',
  cell: '(##) # ####-####',
  date: '##/##/####'
}

export default masks
